const botApi = '/BotServices/bot/'
const TASKCONTAINER = '_FFFFFFFFFFFFFF00001677931223638683_';
const TASKSERVER = '_FFFFFFFFFFFFFF00001698937969553747_';

// window.BotServices.Events.subscribe({
//   next : ((event) => {
//     if(event.Contexts && event.Contexts.length > 0) {
//         let request = {
//           method : 'POST',
//           type : "application/json",
//           url : botApi + ruleEvents,
//           data : event
//         };
//
//         window.BotServices.httpRequest(request, (err, res) => {
//           console.log("sendAlert Server Resp : ", res);
//         });
//     }
//   }),
// });


function ruleEvents(event) {
  //console.log("Got Rule Event", event);
  if(event.Contexts && event.Contexts.length > 0) {
    event.Contexts.forEach((context) => {
      if(context.GrantRightR == 'holder') {
        //console.log("Holder Rule Event", context);
        let request = {
          method : 'POST',
          type : "application/json",
          url : botApi + 'RuleEvents',
          data : context
        };

        window.BotServices.httpRequest(request, (err, res) => {
          console.log("ruleEvents Server Resp : ", res);
        });
      }
    });
  }
  // let params = {
  //   componentId : TASKSERVER,
  //   containerId : TASKCONTAINER,
  //   command : 'TemplateRules',
  //   data : event,
  //   Type : 'BotApi'
  // }
  // window.BotServices.callComponent(params, (err, result) => {});
  // console.log("Got Rule Event");
  // let request = {
  //    method : 'POST',
  //    type : "application/json",
  //    url : botApi + 'RuleEvents',
  //    data : event
  //  };

  //  window.BotServices.httpRequest(request, (err, res) => {
  //    console.log("ruleEvents Server Resp : ", res);
  //  });
}

export {
  ruleEvents
}
